import { observer } from 'mobx-react-lite'
import { Button, Col, Input, InputNumber, Modal, Row, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import i from '../../translations/i'
import __users from '../../front/users/users.controller'

const SelectUsersButton = observer(({ user, selected, onSelect }: any) => {
    const isSelected = selected.find((el: any) => el.id === user.id)

    return(
        <Button
            type={isSelected ? 'primary' : 'dashed'}
            onClick={() => onSelect(user)}
        >
            {isSelected ? i.t('def:Unselect') : i.t('def:Select')}
        </Button>
    )
})

export const SelectUsersModal = observer(({ selected = [], onSelect, title = i.t('def:Select') }: any) => {

    const [open, setOpen] = useState(false)

    useEffect(() => {
        if(open) __users.getList()
    }, [open])

    const columns = [
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'id'
        },
        {
            title: i.t('users:name'),
            key: 'name',
            render: (record: any) => `${record.firstname ?? ''} ${record.lastname ?? ''} ${record.surname ?? ''}`
        },
        {
            title: i.t('users:email'),
            dataIndex: 'email',
            key: 'email'
        },
        {
            title: i.t('users:phone'),
            dataIndex: 'phone',
            key: 'phone'
        },
        {
            title: i.t('points:actions'),
            key: 'action',
            render: (text: any, record: any) => <SelectUsersButton user={record} selected={selected} onSelect={onSelect} />
        },
    ]

    return(
        <>
            <Button onClick={() => setOpen(true)}>
                {title}{selected.length > 0 ? `: ${selected.length}` : ''}
            </Button>

            <Modal
                title={title}
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                width={1000}
                destroyOnClose
            >
                {selected.length > 0 &&
                    <Row gutter={[20, 20]}>
                        <Col span={24}>
                            <label className="all-label">{i.t('def:Selected Users')}</label>
                        </Col>
                        <Col span={24}>
                            <Table
                                columns={columns}
                                dataSource={selected}
                                rowKey="id"
                                size="small"
                                pagination={false}
                            />
                        </Col>
                        <Col span={24}><br/></Col>
                    </Row>
                }

                <Row gutter={[20, 20]}>
                    <Col span={6}>
                        <label>ID</label>
                        <InputNumber
                            value={__users.list_filter.id ?? null}
                            onChange={(e: any) => __users.setFilter('id', e)}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Col span={6}>
                        <label>{i.t('users:name')}</label>
                        <Input
                            value={__users.list_filter.name ?? ''}
                            onChange={(e: any) => __users.setFilter('name', e.target.value)}
                        />
                    </Col>
                    <Col span={6}>
                        <label>{i.t('users:phone')}</label>
                        <Input
                            value={__users.list_filter.phone ?? ''}
                            onChange={(e: any) => __users.setFilter('phone', e.target.value)}
                        />
                    </Col>
                    <Col span={6}>
                        <label>{i.t('users:email')}</label>
                        <Input
                            value={__users.list_filter.email ?? ''}
                            onChange={(e: any) => __users.setFilter('email', e.target.value)}
                        />
                    </Col>
                </Row>

                <br/>

                <Table
                    columns={columns}
                    dataSource={__users.users}
                    rowKey="id"
                    pagination={{
                        total: __users.list.count,
                        current: __users.list.offset === 0 ? 1 : Math.floor(__users.list.offset / __users.list.limit) + 1,
                        pageSize: __users.list.limit,
                        onChange: (page, pageSize) => {
                            __users.list.offset = page > 1 ? (page * __users.list.limit) - __users.list.limit : 0
                            __users.getList()
                        },
                        onShowSizeChange: (current, size) => {
                            __users.list.limit = size
                            __users.list.offset = 0
                            __users.getList()
                        }
                    }}
                />
            </Modal>
        </>
    )
})
